module.exports = __webpack_public_path__ + "static/media/ns.f2db32bd.png";